var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwiiter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.65,
    height: 20.021,
    viewBox: "0 0 24.65 20.021",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-twitter",
    "data-name": "Icon awesome-twitter",
    d: "M22.116,8.37c.016.219.016.438.016.657A14.276,14.276,0,0,1,7.758,23.4,14.277,14.277,0,0,1,0,21.133a10.451,10.451,0,0,0,1.22.063,10.118,10.118,0,0,0,6.272-2.158,5.061,5.061,0,0,1-4.724-3.5,6.371,6.371,0,0,0,.954.078,5.343,5.343,0,0,0,1.329-.172A5.053,5.053,0,0,1,1,10.482v-.063a5.088,5.088,0,0,0,2.284.641A5.06,5.06,0,0,1,1.72,4.3,14.36,14.36,0,0,0,12.137,9.59a5.7,5.7,0,0,1-.125-1.157,5.057,5.057,0,0,1,8.743-3.457,9.947,9.947,0,0,0,3.206-1.22A5.038,5.038,0,0,1,21.741,6.54a10.128,10.128,0,0,0,2.909-.782A10.86,10.86,0,0,1,22.116,8.37Z",
    transform: "translate(0 -3.381)",
    fill: "#3254fe"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwiiter);
export default __webpack_public_path__ + "static/media/twiiter.dc249734181f4a6d835d40cf67def2eb.svg";
export { ForwardRef as ReactComponent };